export enum ECarouselType {
    MOBILE = "MOBILE",
    DESKTOP = "DESKTOP",
}
